module.exports = __webpack_public_path__ + "img/score-10.1baf43f7.png";